import React, {useState, useEffect, useMemo } from 'react';
import authService from '../../api-authorization/AuthorizeService';
import axios from 'axios'
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { ConfirmProvider } from "material-ui-confirm";
import { useConfirm } from "material-ui-confirm";
import { Link } from "react-router-dom";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

export default function FIDEPGNImport() {
    const [token, setToken] = useState();
    const [searchString, setSearchString] = useState("");
    const [selectedUser, setSelectedUser] = useState();
    const [status, setStatus] = useState();
    //const [appData, setAppData] = useState([]);
    const [appData, setAppData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [authenticated, setAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [userRole, setUserRole] = useState("");
    const confirm = useConfirm();
    const [showFailedImport, setShowFailedImport] = useState(true); 
    const [showSuccessfulImport, setShowSuccessfulImport] = useState(false); 

    const handleDelete = (user, popupState, confirm) => {
        confirm({ description: `This will permanently delete ${user.name}.` })
            .then(() => console.log('Deleted ${item}'))
            .catch(() => console.log("Deletion cancelled."));
    };


    useEffect(async () => {
        setToken(await authService.getAccessToken());
        setAuthenticated(await authService.isAuthenticated());
        var user = await authService.getUser();
        if (user != null) {
            var role = user.role;
            setUserRole(role);
            if (role.includes("Administrators")) {
                await setIsAdmin(true);
            }
                
        }
    }, []);

    const isAdminUser = () => {
        if (isAdmin) return true;
        else return false;
    };

    const columns = 
        [
            {
                name: '',
                label: '',
                options: {
                    filter: false,
                    display: true,
                    viewColumns: false,
                    customBodyRender: (value, tableMeta, update) => {
                        let rowIndex = Number(tableMeta.rowIndex) + 1;
                        return (
                            <div style={{ textAlign: "right" }}><span>{rowIndex}</span></div>
                        )
                    }
                }
            },
            {
                name: "id",
                label: "ID",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <a href={"https://ratings.fide.com/tournament_information.phtml?event="+ value} target="_blank"> {value}</a>
                        );
                    }
                }
            },
            {
                name: "name",
                label: "Event Name",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowEvent = appData[originalIndex];
                        return (
                            <a href={"https://ratings.fide.com/report.phtml?event=" + rowEvent.id} target="_blank"> {value}</a>
                        );
                    }
                }
            },
            {
                name: "startDate",
                label: "Start",
                options: {
                    filter: false,
                    sort: true,
                    display: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowEvent = appData[originalIndex];
                        return (
                                <div > {(new Date(value + "Z")).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}</div>
                        );
                    }
                }
            },
            {
                name: "receiveDate",
                label: "Received",
                options: {
                    filter: false,
                    sort: true,
                    display: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowEvent = appData[originalIndex];
                        return (
                            <div > <a href={"https://ratings.fide.com/view_pgn.phtml?code=" + rowEvent.id} target="_blank">{(new Date(value + "Z")).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}</a></div>
                        );
                    }
                }
            },
            {
                name: "ratingDate",
                label: "Rating",
                options: {
                    filter: false,
                    sort: true,
                    display: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowEvent = appData[originalIndex];
                        return (
                            <div > {(new Date(value + "Z")).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}</div>
                        );
                    }
                }
            },
            {
                name: "status",
                label: "S",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    //customBodyRender: (value, tableMeta, updateValue) => {
                    //    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    //    let rowEvent = appData[originalIndex];
                    //    return (
                    //        { value }
                    //    );
                    //}
                }
            },
            {
                name: "pgnExistence",
                label: "P",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    //customBodyRender: (value, tableMeta, updateValue) => {
                    //    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    //    let rowEvent = appData[originalIndex];
                    //    return (
                    //        { value }
                    //    );
                    //}
                }
            },
            {
                name: "pgnImportStatus",
                label: "I",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    //customBodyRender: (value, tableMeta, updateValue) => {
                    //    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    //    let rowEvent = appData[originalIndex];
                    //    return (
                    //        { value }
                    //    );
                    //}
                }
            },
            {
                name: "gamesImported",
                label: "G",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    //customBodyRender: (value, tableMeta, updateValue) => {
                    //    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    //    let rowEvent = appData[originalIndex];
                    //    return (
                    //        { value }
                    //    );
                    //}
                }
            },
            {
                name: "pgnFileLink",
                label: "PGN File",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowEvent = appData[originalIndex];
                        return (
                            <a href={value} target="_blank"> Download</a>
                        );
                    }
                }
            },
            {
                name: "",
                label: "Actions",
                options: {
                    filter: false,
                    filterType: 'multiselect',
                    sort: false,
                    display: true,
                    sortThirdClickReset: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowEvent = appData[originalIndex];
                        return (
                            <div style={{ textAlign: "left" }}>
                                {isAdmin &&
                                    <PopupState variant="popover" popupId="demo-popup-menu">
                                        {(popupState) => (
                                            <React.Fragment>
                                                <Button variant="contained" {...bindTrigger(popupState)}>
                                                    Actions
                                                </Button>
                                                <Menu {...bindMenu(popupState)}>
                                                    <MenuItem onClick={async () => { await markAsPGNNonexistent(rowEvent.id, popupState); }}>Mark as PGN Nonexistent</MenuItem>
                                                    <MenuItem onClick={async () => { await markAsImported(rowEvent.id, popupState); }}>Mark as Imported</MenuItem>
                                                </Menu>
                                            </React.Fragment>
                                        )}
                                    </PopupState>
                                }
                            </div>
                        );
                    }
                }
            }
        ];

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'simple',
        expandableRows: isAdminUser(),
        selectableRows: 'none',
        expandableRowsOnClick: false,
        expandableRowsHeader: false,
        //isRowExpandable: (dataIndex, expandedRows) => {
        //    // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
        //    if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
        //        return false;
        //    return true;
        //},
        isRowExpandable: (dataIndex, expandedRows) => {
            if (isAdmin)
                return true;
            return false;
        },
        //https://openbase.com/js/mui-datatables
        //onRowClick: async (rowData, rowMeta) => {
        //    //let originalIndex = rowMeta.currentTableData[tableMeta.rowIndex].index;
        //    let rowUser = appData[rowMeta.dataIndex];
        //    await setSelectedUser(rowUser)
        //},
        rowsExpanded: [],
        renderExpandableRow: (rowData, rowMeta) => {
            const detail = appData[rowMeta.dataIndex];
            const colSpan = rowData.length + 1;
            console.log(detail);
            return (
                <div><pre>{JSON.stringify(detail, null, 2)}</pre></div>
            );
        },
        onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
            console.log(curExpanded, allExpanded, rowsExpanded),
            
    };

    const theme = createTheme({
        overrides: {
            MUIDataTableSelectCell: {
                expandDisabled: {
                    // Soft hide the button.
                    visibility: 'hidden',
                },
            },
        },
    });

    const components = {
        ExpandButton: function (props) {
            return <ExpandButton {...props} />;
        },
    };

    const getAppData = async (e) => {
        e.preventDefault();
        var t= await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${t}` }
        }
        axios.get('/api/FIDETournaments?showFailedImport=' + showFailedImport + "&showSuccessfulImport=" + showSuccessfulImport, headers).then((response) => {
            setAppData(response.data);
            setStatus("");
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            setStatus("Error - Please check log for details.");
            console.log(JSON.stringify(error));
        });
    };

       
    const markAsImported = async (id, popupState) => {
        popupState.close();
        const myToken = await authService.getAccessToken();
        const requestOptions = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myToken,
            },
            body: JSON.stringify(id)
        };
        const res = await fetch('/api/FIDETournaments/MarkAsImported/' + id, requestOptions);
        if (res.ok) {
            setAppData(prevState => {
                const newState = prevState.map(obj => {
                    if (obj.id === id) {
                        return { ...obj, pgnExistence: 1, pgnImportStatus: 1 };
                    }
                    return obj;
                });
                return newState;
            });
        }
    }

    const markAsPGNNonexistent = async (id, popupState) => {
        popupState.close();
        const myToken = await authService.getAccessToken();
        const requestOptions = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myToken,
            },
            body: JSON.stringify(id)
        };
        const res = await fetch('/api/FIDETournaments/MarkAsPGNNonexistent/' + id, requestOptions);
        if (res.ok) {
            setAppData(prevState => {
                const newState = prevState.map(obj => {
                    if (obj.id === id) {
                        return { ...obj, pgnExistence: 0, pgnImportStatus:0 };
                    }
                    return obj;
                });
                return newState;
            });
        }
    }


    return (
        <div className="Container" style={{ position: 'relative' }}>
            <Accordion m={2} pt={3} pl={3} pr={3} defaultExpanded={true}>
                <AccordionSummary aria-controls="event-info" id="event-info" expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#1976d2' }}>
                    <Typography color='white'>FIDE PGN Files</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box sx={{ pt: 2, pb: 2 }}>
                        <Grid container direction="row" rowSpacing={1} columnSpacing={1} align-items="flex-end">
                            <Grid item xs={12} lg={3} >
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox defaultChecked checked={showSuccessfulImport} onChange={e => { setShowSuccessfulImport(e.target.checked); }} />} label="Show Succeful Import" />
                                </FormGroup>
                            </Grid>

                            <Grid item xs={12} lg={4} >
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox defaultChecked checked={showFailedImport} onChange={e => { setShowFailedImport(e.target.checked); }} />} label="Show Failed Import" />
                                </FormGroup>
                            </Grid>

                            <Grid item xs={12} lg={5}>
                                <Stack spacing={1} direction="row" justifyContent="end">
                                    <LoadingButton
                                        fullWidth
                                        onClick={async (e) => {
                                            await setLoading(true); await getAppData(e);
                                        }
                                        }
                                        loading={loading}
                                        loadingIndicator="Loading..."
                                        variant="contained"
                                        disabled={!showSuccessfulImport && !showFailedImport}
                                    >
                                        Show FIDE PGN Imports
                                    </LoadingButton>
                                </Stack>
                            </Grid>
                            <Grid item xs={12}>
                                <div>
                                    <label style={{ color: 'red' }}>{status}</label>
                                </div>
                            </Grid>
                            {appData.length > 0 &&
                                <Grid item xs={12}>
                                    <CacheProvider value={muiCache}>
                                        <ThemeProvider theme={theme}>
                                            <MUIDataTable
                                                title={<div>
                                                    <Button variant="contained" color="secondary" onClick={async (e) => { e.preventDefault(); await setAppData([]); await setSelectedUser(); await setSearchString("") }}>{"Clear Results (" + appData.length + ")"}</Button>
                                                </div>}
                                                data={appData}
                                                columns={columns}
                                                options={options}
                                                components={components}
                                            />
                                        </ThemeProvider>
                                    </CacheProvider>
                                </Grid>
                            }
                        </Grid>
                    </Box>
                </AccordionDetails>
            </Accordion>
        </div>
    )
}
